// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//     className?: string
//     chartColor?: string
//     chartHeight?: string
//     percentage: number
//     title: string
//     cardWidth?: string
// }

// const TryWid: React.FC<Props> = ({
//     className,
//     chartColor = 'primary',
//     chartHeight = '180px',
//     percentage,
//     title,
//     cardWidth
// }) => {
//     const chartRef = useRef<HTMLDivElement | null>(null)
//     const { mode } = useThemeMode()

//     const refreshChart = () => {
//         if (!chartRef.current) return
//         const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, percentage))
//         chart.render()
//         return chart
//     }

//     useEffect(() => {
//         const chart = refreshChart()
//         return () => {
//             if (chart) chart.destroy()
//         }
//     }, [chartRef, mode, percentage])

//     return (
//         <div className={`card ${className}`} style={cardWidth ? { maxWidth: cardWidth } : undefined}>
//             <div className='card-body d-flex flex-column justify-content-between' style={{ padding: '0rem 0rem' }}>
//                 <div className='d-flex justify-content-center align-items-center flex-grow-1'>
//                     <div
//                         ref={chartRef}
//                         style={{ width: '100%', maxWidth: chartHeight }}
//                     />
//                 </div>
//                 <div className='text-center mt-3'>
//                     <h4 className='fw-bold mb-0' style={{ fontSize: '1rem' }}>
//                         {title}
//                     </h4>
//                 </div>
//             </div>
//         </div>
//     )
// }

// const chartOptions = (
//     chartColor: string,
//     chartHeight: string,
//     percentage: number
// ): ApexOptions => {
//     const baseColor = getCSSVariableValue('--bs-' + chartColor)
//     const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')
//     const labelColor = getCSSVariableValue('--bs-gray-700')

//     return {
//         series: [percentage],
//         chart: {
//             height: chartHeight,
//             type: 'radialBar',
//             sparkline: { enabled: true },
//         },
//         labels: [],
//         plotOptions: {
//             radialBar: {
//                 hollow: { margin: 0, size: '60%' },
//                 dataLabels: {
//                     name: { show: false },
//                     value: {
//                         show: true,
//                         fontSize: '18px',
//                         fontWeight: '700',
//                         color: labelColor,
//                         offsetY: 5,
//                         formatter: val => `${val} %`,
//                     },
//                 },
//                 track: {
//                     background: lightColor,
//                     strokeWidth: '100%',
//                 },
//             },
//         },
//         colors: [baseColor],
//         stroke: { lineCap: 'round' },
//     }
// }

// export { TryWid }




/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className?: string
  chartColor?: string
  chartHeight?: string
  percentage: number
  title: string
  cardWidth?: string
}

const TryWid: React.FC<Props> = ({
  className,
  chartColor = 'primary',
  chartHeight = '180px',
  percentage,
  title,
  cardWidth
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) return
    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, percentage))
    chart.render()
    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) chart.destroy()
    }
  }, [chartRef, mode, percentage])

  return (
    <div className={`card ${className}`} style={cardWidth ? { maxWidth: cardWidth } : undefined}>
      <div className='card-body d-flex flex-column justify-content-between' style={{ padding: '0rem 0rem' }}>
        <div className='text-center mt-3'>
          <p className='fw-bold mb-0' style={{ fontSize: '1.35rem', fontWeight: "bold", color: "#000000" }}>
            {title}
          </p>
        </div>
        <div className='d-flex justify-content-center align-items-center flex-grow-1'>
          <div
            ref={chartRef}
            style={{ width: '100%', maxWidth: chartHeight }}
          />
        </div>

      </div>
    </div>
  )
}

const chartOptions = (
  chartColor: string,
  chartHeight: string,
  percentage: number
): ApexOptions => {
  const baseColor = chartColor.startsWith('#')
    ? chartColor
    : getCSSVariableValue('--bs-' + chartColor)

  const lightColor = chartColor.startsWith('#')
    ? chartColor + '33'
    : getCSSVariableValue('--bs-' + chartColor + '-light')

  const labelColor = getCSSVariableValue('--bs-gray-700')

  return {
    series: [percentage],
    chart: {
      height: chartHeight,
      type: 'radialBar',
      sparkline: { enabled: true },
    },
    labels: [],
    plotOptions: {
      radialBar: {
        hollow: { margin: 0, size: '60%' },
        dataLabels: {
          name: { show: false },
          value: {
            show: true,
            fontSize: '18px',
            fontWeight: '700',
            color: labelColor,
            offsetY: 5,
            formatter: val => `${val} %`,
          },
        },
        track: {
          background: lightColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: { lineCap: 'round' },
  }
}

export { TryWid }